module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-titel"
  }, [_c('translate', [_vm._v("Verify the MFA device")])], 1), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    on: {
      "change": _vm.onInputCode
    },
    model: {
      value: (_vm.securityCode),
      callback: function($$v) {
        _vm.securityCode = $$v
      },
      expression: "securityCode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCansubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitVerify()
      }
    }
  }, [_c('translate', [_vm._v("Submit validation")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.bindMfa = true
      }
    }
  }, [_c('translate', [_vm._v("(MFA verify notes)")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 2013-2017 "), _c('translate', [_vm._v("Shanghai Zhuyun Information Technology Co.,Ltd")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "MFA验证须知",
      "visible": _vm.bindMfa
    },
    on: {
      "update:visible": function($event) {
        _vm.bindMfa = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("1. You must install the MFA application on your smart device to continue.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("2. Common applications that support MFA on smart devices are ")]), _c('a', {
    staticStyle: {
      "color": "#20a0ff"
    },
    attrs: {
      "href": "https://promotion.aliyun.com/ntms/mobile.html",
      "target": "view_window"
    }
  }, [_c('translate', [_vm._v("Identity")])], 1), _c('translate', [_vm._v(", Microsoft Authenticator, Google Authenticator.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("3. If your account has been shared by multiple people, then when you successfully bind MFA, other unbound MFA people will not be able to log in. The solution is to let other people also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to follow the sweep. But from the security best practice, we recommend that you cancel the multiplayer account.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bindMfa = false
      }
    }
  }, [_c('translate', [_vm._v("Comfirm")])], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo4.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Powered by\n      "), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://cloudcare.cn/",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bde6e5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mfaComfirm.vue
// module id = 602
// module chunks = 4 5 6